import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getVehicleTypeCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleType}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getVehicleTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertVehicleType = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.VehicleType,
    input
  );
  return data;
};

const updateVehicleType = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.VehicleType,
    input
  );
  return data;
};

const deleteVehicleType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.VehicleType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useVehicleTypeCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleType],
    queryFn: () => getVehicleTypeCategories(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetVehicleTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleType],
    queryFn: () => getVehicleTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertVehicleTypeMutation = () => {
  return useMutation({
    mutationFn: insertVehicleType,
  });
};

export const useUpdateVehicleTypeMutation = () => {
  return useMutation({
    mutationFn: updateVehicleType,
  });
};

export const useDeleteVehicleTypeMutation = () => {
  return useMutation({
    mutationFn: deleteVehicleType,
  });
};
